import { type Dispatch, type SetStateAction, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import CardBody from 'components/Card/CardBody';
import CardWrapper from 'components/Card/CardWrapper';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import InfoIconTooltip from 'components/InfoIconTooltip/InfoIconTooltip';
import LabeledCheckbox from 'components/Checkbox/LabeledCheckbox';
import { Dialog } from '@material-ui/core';
import SweetAlert from 'react-bootstrap-sweetalert';
import { makeStyles } from '@material-ui/styles';
import Button from 'components/CustomButtons/Button';

import ImportDiscountCodeSections from './ImportDiscountCodeSections';

const useStyles = makeStyles({
  sweetAlertDescription: {
    fontWeight: '500',
    fontSize: '14px',
  },
  button: { marginLeft: '10px' },
});

type GeolocationRestrictionsSectionProps = {
  hasGeolocationRestrictions: boolean;
  setHasGeolocationRestrictions: Dispatch<SetStateAction<boolean>>;
  importedDiscountCodes: string[];
  setImportedDiscountCodes: Dispatch<SetStateAction<string[]>>;
};

const GeolocationRestrictionsSection = ({
  hasGeolocationRestrictions,
  setHasGeolocationRestrictions,
  importedDiscountCodes,
  setImportedDiscountCodes,
}: GeolocationRestrictionsSectionProps) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [isTurnOffGeolocationModalOpen, setIsTurnOffGeolocationModalOpen] =
    useState(false);

  return (
    <>
      <CardWrapper title={t('geolocationRestrictions')}>
        <CardBody>
          <GridContainer>
            <GridItem>
              <LabeledCheckbox
                label={
                  <>
                    {t('discountCodeWorksOnlyForChosenLocations')}
                    <InfoIconTooltip
                      title={<Trans i18nKey="geolocationRestrictionsInfo" />}
                    />
                  </>
                }
                checked={hasGeolocationRestrictions}
                onChange={e => {
                  if (!e.target.checked && importedDiscountCodes.length > 0) {
                    setIsTurnOffGeolocationModalOpen(true);

                    return;
                  }

                  setHasGeolocationRestrictions(e.target.checked);
                }}
              />
            </GridItem>
          </GridContainer>
          {hasGeolocationRestrictions && (
            <ImportDiscountCodeSections
              importedDiscountCodes={importedDiscountCodes}
              setImportedDiscountCodes={setImportedDiscountCodes}
            />
          )}
        </CardBody>
      </CardWrapper>
      <Dialog fullWidth={true} open={isTurnOffGeolocationModalOpen}>
        <SweetAlert
          warning={true}
          title={t('discountCodes.turnOffGeolocationRestrictions.areYouSure')}
          // eslint-disable-next-line @typescript-eslint/no-empty-function -- FIXME
          onConfirm={() => {}}
          // eslint-disable-next-line @typescript-eslint/no-empty-function -- FIXME
          onCancel={() => {}}
          showConfirm={false}
          showCancel={false}
        >
          <p className={classes.sweetAlertDescription}>
            {t('discountCodes.turnOffGeolocationRestrictions.description')}
          </p>
          <Button
            onClick={() => {
              setIsTurnOffGeolocationModalOpen(false);
            }}
          >
            {t('common.cancel')}
          </Button>
          <Button
            onClick={() => {
              setImportedDiscountCodes([]);
              setHasGeolocationRestrictions(false);
              setIsTurnOffGeolocationModalOpen(false);
            }}
            color="danger"
            className={classes.button}
          >
            {t('discountCodes.turnOffGeolocationRestrictions.yes')}
          </Button>
        </SweetAlert>
      </Dialog>
    </>
  );
};

export default GeolocationRestrictionsSection;
